<template lang="html">
  <div class="md-autocomplete"
    @focus="onFocus"
    @blur="onBlur">
    <md-menu :md-offset-x="8"
      md-offset-y="45"
      ref="menu"
      class="md-autocomplete-menu">
      <span md-menu-trigger></span>
      <md-layout md-flex="100">
        <md-layout md-flex="80">
          <input class="md-input"
            ref="input"
            type="text"
            v-model="query"
            :disabled="disabled"
            required="required"
            :placeholder="placeholder"
            :maxlength="maxlength"
            :name="name"
            @focus="onFocus"
            @blur="onBlur"
            @input="debounceUpdate">
            </input>
        </md-layout>
        <md-layout md-flex="20">
          <div style="text-align:right; width:100%; cursor:pointer">
            <md-icon @click.native="makeFetchRequest">search</md-icon>
          </div>
        </md-layout>
      </md-layout>

      <md-menu-content style="width:330px; max-height:400px">
        <md-menu-item v-if="loading">
          <md-layout md-align="center">
            <md-spinner id="spinner" :md-size="30" :md-stroke="2" md-indeterminate></md-spinner>
          </md-layout>
        </md-menu-item>
        <md-menu-item v-for="(item, index) in items"
          v-if="items.length && !printFunction && !loading"
          :key="index"
          @keyup.enter="hit(item)"
          @click.native="hit(item)">
          {{ item[printAttribute] }}
        </md-menu-item>
        <md-menu-item v-for="(item, index) in items"
          v-if="items.length && printFunction && !loading"
          :key="index"
          @keyup.enter="hit(item)"
          @click.native="hit(item)">
          {{ printFunction(item) }}
        </md-menu-item>
        <!--botao cadastro extencoes-->
        <md-menu-item
          v-if="extensao && !items.length && !loading"
          @click.native="emptyAction">
          {{ $t('label.cadastrar_extensao') }}
        </md-menu-item>
        <md-menu-item
          v-if="!extensao && !items.length && !loading"
          >
          No se encontraron resultados
        </md-menu-item>
      </md-menu-content>
    </md-menu>
  </div>
</template>

<script>
  import autocompleteCommon from '../../common/functions/autocomplete';
  import common from './common';
  import { getClosestVueParent } from '../../common/functions/helpers';
  import { skipLoading } from '../../common/functions/loading';

  export default {
    mixins: [common, autocompleteCommon],
    props: {
      extensao: {
        type: Boolean,
        default: false,
      },
      chips: {
        type: Array,
        default: null,
      },
      identifier: {
        type: String,
        default: 'id',
      },
      printFunction: {
        type: Function,
        default: null,
      },
    },
    data() {
      return {
        items: [],
        loading: false,
        query: '',
        selected: null,
        timeout: 0,
        parentContainer: null,
        searchButton: null,
      };
    },
    computed: {
      listIsEmpty() {
        return this.list.length === 0;
      },
    },
    watch: {
      list(value) {
        this.items = Object.assign([], value);
      },
      query(value) {
        this.$refs.input.value = value;
        this.setParentUpdateValue(value);
        if (value === '') {
          this.emptyAction();
        }
      },
      value(value) {
        this.query = value;
        this.setParentUpdateValue(value);
      },
    },
    methods: {
      debounceUpdate() {
        this.onInput();

        if (this.timeout) {
          window.clearTimeout(this.timeout);
        }

        this.timeout = window.setTimeout(() => {
          if (!this.listIsEmpty) {
            this.renderFilteredList();
            return;
          }
          this.update();
        }, this.debounce);
      },
      hit(item) {
        this.query = item[this.printAttribute];
        this.$refs.input.value = item[this.printAttribute];
        this.selected = item;
        this.onInput();
        this.$emit('selected', this.selected, this.$refs.input.value);
      },
      makeFetchRequest(queryObject) {
        if (this.disabled) {
          return null;
        }
        this.loading = true;
        this.toggleMenu();
        skipLoading();
        return this.fetch(queryObject)
          .then((response) => {
            let data = response.body.data;
            data = this.prepareResponseData ?
              this.prepareResponseData(data) :
              data;
            this.items = this.limit ?
              data.slice(0, this.limit) :
              data;
            if (this.chips) {
              const found = [];
              this.items.forEach((items, index) => {
                this.chips.forEach((chip) => {
                  if (items[this.identifier] === chip[this.identifier]) {
                    found.push(index);
                  }
                });
              });
              for (let i = found.length - 1; i >= 0; i -= 1) {
                this.items.splice(found[i], 1);
              }
            }
            this.loading = false;
          });
      },
      onFocus() {
        if (this.parentContainer) {
          this.parentContainer.isFocused = true;
        }
        this.$refs.input.focus();
      },
      onInput() {
        this.updateValues();
        this.$emit('change', this.$refs.input.value);
        this.$emit('input', this.$refs.input.value);
      },
      emptyAction() {
        this.$emit('empty');
      },
      renderFilteredList() {
        if (this.filterList) {
          this.items = this.filterList(Object.assign([], this.list), this.query);
        }
        this.toggleMenu();
      },
      reset() {
        this.items = [];
        this.query = '';
        this.loading = false;
      },
      setParentValue(value) {
        this.parentContainer.setValue(value || this.$refs.input.value);
      },
      setParentDisabled() {
        this.parentContainer.isDisabled = this.disabled;
      },
      setParentRequired() {
        this.parentContainer.isRequired = this.required;
      },
      setParentPlaceholder() {
        this.parentContainer.hasPlaceholder = !!this.placeholder;
      },
      setParentUpdateValue(value) {
        this.setParentValue(value);
        this.updateValues(value);
      },
      setSearchButton() {
        this.searchButton = this.parentContainer.$el.querySelector('[md-autocomplete-search]');

        if (this.searchButton) {
          this.searchButton.addEventListener('click', this.makeFetchRequest);
        }
      },
      update() {
        if (!this.query && !this.list.length) {
          return this.reset();
        }

        if (this.minChars && this.query.length < this.minChars) {
          return this;
        }

        this.loading = true;

        const queryObject = { [this.queryParam]: this.query };

        return this.makeFetchRequest(queryObject);
      },
      toggleMenu() {
        this.$refs.menu.toggle();
      },
      updateValues(value) {
        const newValue = value || this.$refs.input.value || this.value;

        this.setParentValue(newValue);
        this.parentContainer.inputLength = newValue ? newValue.length : 0;
      },
    },
    beforeDestroy() {
      if (this.searchButton) {
        this.searchButton.removeEventListener('click', this.makeFetchRequest);
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.parentContainer = getClosestVueParent(this.$parent, 'md-input-container');

        if (!this.listIsEmpty) {
          this.items = Object.assign([], this.list);
        }

        this.query = this.value;

        this.verifyProps();
        this.setSearchButton();

        this.setParentDisabled();
        this.setParentRequired();
        this.setParentPlaceholder();
        this.handleMaxLength();
        this.updateValues();
      });
    },
  };
</script>

<style src="./mdAutocomplete.scss" lang="scss"></style>
<style>
  .md-input-container:after {
    bottom: 2px
  }
</style>



// WEBPACK FOOTER //
// src/shared-components/autocomplete/mdAutocomplete.vue